import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';
import { EventLocationInput, EventLocationTypeEnum, GeoLocation } from '@/types/schema';

import LocationPreview from './LocationPreview';
import LocationSearch from './LocationSearch';

type AddLocationProps = {
  className?: string;
  location: EventLocationInput;
  onChange: (updatedLocation: EventLocationInput) => void;
  disabled?: boolean;
};

function AddLocation({ className, location, onChange, disabled }: AddLocationProps) {
  const { t } = useTranslation();

  return (
    <Box className={cn('flex flex-col', className)}>
      <Typography className={cn('mb-24 ps-8')} variant="heading-s">
        {t('Events:Editor.AddLocationTitle')}
      </Typography>
      <LocationSearch disabled={disabled} location={location} onChange={onChange} />
      {location.type === EventLocationTypeEnum.GeoLocation ? (
        <LocationPreview className="mt-12" geoLocation={location.geoLocation as GeoLocation} />
      ) : null}
    </Box>
  );
}

export default React.memo(AddLocation);
